"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DisabilityPageOne;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _DisabilityWizardFormControls = require("./DisabilityWizardFormControls");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function DisabilityPageOne() {
  var {
    values: {
      birthMonth,
      birthDay,
      birthYear,
      annualEarnedIncome,
      estimatedMonthlyExpenses,
      haveEmployerPlan,
      cashSavings,
      planningIndicator
    },
    errors,
    touched,
    values,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = (0, _formik.useFormikContext)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DisabilityWizardFormControls.BirthDay, {
    errors: errors,
    touched: touched,
    birthDay: birthDay,
    birthMonth: birthMonth,
    birthYear: birthYear,
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched,
    setFieldError: setFieldError
  }), /*#__PURE__*/_react.default.createElement(_DisabilityWizardFormControls.AnnualEarnedIncome, {
    annualEarnedIncome: annualEarnedIncome,
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched,
    setFieldError: setFieldError,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_DisabilityWizardFormControls.EstimatedMonthlyExpenses, {
    estimatedMonthlyExpenses: estimatedMonthlyExpenses,
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched,
    setFieldError: setFieldError,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_DisabilityWizardFormControls.HaveEmployerPlan, {
    haveEmployerPlan: haveEmployerPlan,
    setFieldValue: setFieldValue,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_DisabilityWizardFormControls.PlanningIndicator, {
    planningIndicator: planningIndicator,
    setFieldValue: setFieldValue,
    values: values
  }), /*#__PURE__*/_react.default.createElement(_DisabilityWizardFormControls.CashSavings, {
    cashSavings: cashSavings,
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched,
    setFieldError: setFieldError,
    values: values
  }));
}